// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__32jg-","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__38ozn"};